export default __webpack_public_path__ + "static/media/vae6.794464c8.png";